var _defs, _g, _path, _g2, _g3, _g4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgRainDay(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 64 64",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "m12 35-5.28-4.21-2-6 1-7 4-5 5-3h6l5 1 3 3L33 20l-6 4h-6l-3 3v4l-4 2-2 2z"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#f59e0b",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 2,
    d: "M23.5 24a4.5 4.5 0 1 1-4.5-4.5 4.49 4.49 0 0 1 4.5 4.5zM19 15.67V12.5m0 23v-3.17m5.89-14.22 2.24-2.24M10.87 32.13l2.24-2.24m0-11.78-2.24-2.24m16.26 16.26-2.24-2.24M7.5 24h3.17m19.83 0h-3.17"
  }), /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    dur: "45s",
    from: "0 19 24",
    repeatCount: "indefinite",
    to: "360 19 24",
    type: "rotate"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#e5e7eb",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3,
    d: "M43.67 45.5h2.83a7 7 0 0 0 0-14h-.32a10.49 10.49 0 0 0-19.11-8 7 7 0 0 0-10.57 6 7.21 7.21 0 0 0 .1 1.14A7.5 7.5 0 0 0 18 45.5a4.19 4.19 0 0 0 .5 0v0"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#2885c7",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 2,
    d: "m24.39 43.03-.78 4.94"
  }), /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    dur: "0.7s",
    repeatCount: "indefinite",
    type: "translate",
    values: "1 -5; -2 10"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "opacity",
    dur: "0.7s",
    repeatCount: "indefinite",
    values: "0;1;1;0"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#2885c7",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 2,
    d: "m31.39 43.03-.78 4.94"
  }), /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    begin: "-0.4s",
    dur: "0.7s",
    repeatCount: "indefinite",
    type: "translate",
    values: "1 -5; -2 10"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "opacity",
    begin: "-0.4s",
    dur: "0.7s",
    repeatCount: "indefinite",
    values: "0;1;1;0"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#2885c7",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 2,
    d: "m38.39 43.03-.78 4.94"
  }), /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    begin: "-0.2s",
    dur: "0.7s",
    repeatCount: "indefinite",
    type: "translate",
    values: "1 -5; -2 10"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "opacity",
    begin: "-0.2s",
    dur: "0.7s",
    repeatCount: "indefinite",
    values: "0;1;1;0"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRainDay);
export default __webpack_public_path__ + "static/media/rain-day.f64a5b59c8f7f6ef5fc2483086cfb1ef.svg";
export { ForwardRef as ReactComponent };